import { testDataCreator, uuid } from '@wix/answers-lib';
// tslint:disable-next-line: max-line-length
import { WidgetBackgroundPattern, WidgetLauncherIcon, WidgetContentModuleType, WidgetLauncherSize } from './domain';
import { ContentVisibilitySettingsBuilder } from '../../domain/settings/content-visibility-settings';
import { CsatContentBuilder } from '../../domain/csat/builders';
import { downTimeBuilder, openingHoursBuilder, tenantScheduleBuilder } from '../../domain/common/tenant-schedule/tenant-schedule.builder';
import { ChatbotApiHttpMethod, ChatbotStepType } from './chatbot-poc/types';
export var widgetMetadataBuilder = testDataCreator({
    name: 'bobobbo',
    id: '123123-123123-123-123-2-21123',
    enabled: true,
    lastUpdateDate: 1557150813,
    brandId: '123123-123123-123-123-2-21123',
    enabledContactTypes: []
});
export var widgetAppearanceSettingsBuilder = testDataCreator({
    widgetStyle: {
        backgroundColor: '#19647E',
        actionColor: '#4B3F72',
        backgroundKey: WidgetBackgroundPattern.PARTY,
        font: {
            name: 'FiraSans',
            url: 'https://code.cdn.mozilla.net/fonts/woff/FiraSans-Regular.woff'
        },
        answersBannerEnabled: true
    },
    launcherStyle: {
        iconKey: WidgetLauncherIcon.COMPASS,
        iconShapeConvex: 40,
        alignment: 10,
        pixelsFromEdge: 2,
        pixelsFromBottom: 5,
        widgetDraggable: false,
        launcherSize: WidgetLauncherSize.SMALL
    }
});
export var widgetAdvancedSettingsBuilder = testDataCreator({
    customCssPath: '',
    customJsPath: '',
    allowedDomains: [],
    requireAuthenticationEnabled: false
});
export var widgetOpeningHoursBuilder = openingHoursBuilder;
export var widgetSettingsContentsBuilder = testDataCreator({
    en: {
        title: 'bob title',
        subtitle: 'bob subtitle',
        subtitleEnabled: true,
        widgetLauncherTextSettings: {
            iconMessageEnabled: false,
            iconMessage: 'hello icon',
            iconWelcomeMessageEnabled: false,
            iconWelcomeMessage: 'welcome',
            delayWelcomeMessageEnabled: true,
            welcomeMessageDelaySeconds: 10
        },
        searchBar: {
            id: 'bob0b-123',
            enabled: true,
            title: 'search bar title'
        },
        categories: {
            id: '123-123-21-3123213',
            enabled: true,
            title: 'categories title'
        },
        featuredArticles: {
            id: '123-123-2123',
            enabled: true,
            title: 'featured articles title',
            articleIds: []
        },
        contact: {
            id: 'bob-contact-123',
            enabled: true,
            chatSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                emailMandatory: false,
                enabled: false,
                greetingMessage: '',
                greetingMessageEnabled: false,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                scheduleId: 'some-schedule-id',
                chatClosedMessageEnabled: true,
                chatClosedMessage: '',
                responseTimeMessageEnabled: false,
                responseTimeMessage: '',
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                csatEnabled: true,
                csatCustomized: true,
                csatContent: new CsatContentBuilder().build(),
                sendViaEmailEnabled: true,
                savedFilterId: null,
                shouldNewMessageReopenClosedChat: true,
                multipleActiveChatEnabled: true,
                useSchedule: false
            },
            callbackSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                displayWaitTimeEnabled: false,
                enabled: false,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                ticketDescriptionEnabled: true,
                useSchedule: false
            },
            contactFormSettings: {
                agentAvatarsEnabled: true,
                customFields: [],
                customFieldsEnabled: false,
                enabled: true,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                responseTimeMessageEnabled: true,
                responseTimeMessage: 'We typically reply in a few days',
                issueSelections: [],
                subtitle: 'Our support agents are here to help',
                subtitleEnabled: true,
                title: 'Contact us by Email',
                ticketDescriptionEnabled: true,
                useSchedule: false
            },
            limitContactExposureEnabled: false
        },
        customHtmls: [
            { id: 'bob-1234', html: '<div>bob second son</div>' }
        ],
        contentScope: new ContentVisibilitySettingsBuilder().build(),
        modulesOrder: [
            { id: 'bob-contact-123', widgetContentModuleType: WidgetContentModuleType.CONTACT },
            { id: 'module-id-321', widgetContentModuleType: WidgetContentModuleType.CATEGORY_LIST },
            { id: 'bob-123', widgetContentModuleType: WidgetContentModuleType.CUSTOM_HTML },
            { id: '123-123-212', widgetContentModuleType: WidgetContentModuleType.FEATURED_ARTICLES },
            { id: 'bob-1234', widgetContentModuleType: WidgetContentModuleType.CUSTOM_HTML },
            { id: 'bob-1235', widgetContentModuleType: WidgetContentModuleType.SEARCH_BAR },
        ]
    },
    de: {
        title: 'bob title',
        subtitle: 'bob subtitle',
        subtitleEnabled: true,
        widgetLauncherTextSettings: {
            iconMessageEnabled: true,
            iconMessage: 'halo icon',
            iconWelcomeMessageEnabled: true,
            iconWelcomeMessage: 'halo',
            delayWelcomeMessageEnabled: true,
            welcomeMessageDelaySeconds: 10
        },
        searchBar: {
            id: 'bob0b-123',
            enabled: true,
            title: 'search bar title'
        },
        categories: {
            id: '123-123-21-3123213',
            enabled: true,
            title: 'categories title'
        },
        featuredArticles: {
            id: '123-123-2123',
            enabled: true,
            title: 'featured articles title',
            articleIds: []
        },
        contact: {
            id: 'bob-contact-123',
            enabled: true,
            chatSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                emailMandatory: false,
                enabled: false,
                greetingMessage: '',
                greetingMessageEnabled: false,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                chatClosedMessageEnabled: false,
                chatClosedMessage: '',
                responseTimeMessageEnabled: false,
                responseTimeMessage: '',
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                csatEnabled: true,
                csatCustomized: true,
                csatContent: new CsatContentBuilder().build(),
                sendViaEmailEnabled: true,
                savedFilterId: null,
                shouldNewMessageReopenClosedChat: true,
                multipleActiveChatEnabled: true,
                useSchedule: false
            },
            callbackSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                displayWaitTimeEnabled: false,
                enabled: false,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                ticketDescriptionEnabled: true,
                useSchedule: false
            },
            contactFormSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                enabled: true,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                responseTimeMessageEnabled: false,
                responseTimeMessage: '',
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                ticketDescriptionEnabled: true,
                useSchedule: false
            },
            limitContactExposureEnabled: true
        },
        customHtmls: [
            { id: 'bob-123', html: '<div>bob son</div>' }
        ],
        contentScope: new ContentVisibilitySettingsBuilder().build(),
        modulesOrder: [
            { id: 'module-id-321', widgetContentModuleType: WidgetContentModuleType.CATEGORY_LIST },
            { id: 'module-id-123', widgetContentModuleType: WidgetContentModuleType.CUSTOM_HTML }
        ]
    }
});
export var widgetNewSettingsBuilder = testDataCreator({
    enabled: true,
    advanced: widgetAdvancedSettingsBuilder(),
    appearance: widgetAppearanceSettingsBuilder(),
    contents: widgetSettingsContentsBuilder()
});
export var widgetScheduleBuilder = testDataCreator({
    schedule: tenantScheduleBuilder({}),
    downtimes: [downTimeBuilder({})]
});
export var widgetSchedulesMapBuilder = testDataCreator({
    CHAT: widgetScheduleBuilder({}),
    CALLBACK: widgetScheduleBuilder({}),
    CONTACT_FORM: widgetScheduleBuilder({})
});
export var chatbotMessageStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Messages Step',
    type: ChatbotStepType.MESSAGES,
    messages: [],
    target: '',
});
export var chatbotInputStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Input Step',
    type: ChatbotStepType.INPUT,
});
export var chatbotApiStepBuilder = testDataCreator({
    id: uuid(),
    name: 'API Step',
    type: ChatbotStepType.API,
    url: '',
    contextVariable: 'lastApiCall',
    fallbackTarget: '',
    method: ChatbotApiHttpMethod.GET,
    target: ''
});
export var chatbotConditionsStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Conditions Step',
    type: ChatbotStepType.CONDITIONS,
    target: '',
    conditions: [],
    fallbackTarget: ''
});
export var chatbotCustomFieldsStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Custom Fields Step',
    type: ChatbotStepType.SET_CUSTOM_FIELDS,
    target: '',
    customFields: {},
});
export var chatbotIdentifyUserStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Identify User Step',
    type: ChatbotStepType.IDENTIFY_USER,
    target: '',
});
export var chatbotLiveChatStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Live Chat Step',
    type: ChatbotStepType.LIVE_CHAT,
});
export var chatbotContactFormStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Email Form Step',
    type: ChatbotStepType.CONTACT_FORM,
});
export var chatbotExitStepBuilder = testDataCreator({
    id: uuid(),
    name: 'Exit Step',
    type: ChatbotStepType.EXIT,
});
export var chatbotFlowBuilder = testDataCreator({
    id: 'example-flow',
    name: 'New Flow',
    rootId: 'first-step',
    tenantName: 'test-tenant',
    nodePositions: {},
    steps: { 'first-step': chatbotMessageStepBuilder({ id: 'first-step' }) },
});
//# sourceMappingURL=builders.js.map